module.exports = __webpack_public_path__ + "img/geofisica3_4-3_2048.a8745587.webp";